module.exports = __webpack_public_path__ + "static/media/cm.348d9271.svg";